import CanvasObject from "./objects/CanvasObject";
import Colors from "./../../utils/Colors.js";
import Bezier from "./../../utils/bezier.js";

import KeyframeObject from "./objects/KeyframeObject.js";

export default class TOwOBject extends CanvasObject {
    keyframes = {};
    primaryColor = null;

    keyframeObjects = [];
    startTime = 0;
    duration = 0;

    constructor(parent, property, x, y, width, height, keyframes, options) {
        super(
            parent,
            { x, y, width, height, draggable: false, type: "custom" },
            {},
            { skipMeForNearObjs: true }
        );

        this.property = property;
        this.keyframes = keyframes || {};
        this.options = options || {};

        this.primaryColor = this.options.primaryColor || Colors.from("#47ACF9");

        this.init();
    }

    keyframesDidUpdate(newKF) {
        this.updateKeyframes(newKF);
    }

    updateKeyframes(newKF) {
        if (!this.keyframes.length && (!newKF || !newKF.length)) return;

        // console.log(newKF && newKF.length);

        if (newKF) {
            this.keyframes = newKF;
        }

        this.startTime = this.keyframes[0].time;
        this.duration =
            this.keyframes.length > 1
                ? this.keyframes[this.keyframes.length - 1].time -
                  this.startTime
                : 0;

        this.minValue = this.keyframes.reduce(
            (min, p) => (p.value < min ? p.value : min),
            this.keyframes[0].value
        );
        this.maxValue = this.keyframes.reduce(
            (max, p) => (p.value > max ? p.value : max),
            this.keyframes[0].value
        );

        // this.removeObjects(...this.keyframeObjects);
        this.keyframeObjects = [];
        for (let kf of this.keyframes) {
            const x = (kf.time / this.duration) * this.width + this.x;

            const newKFObj = new KeyframeObject(
                this,
                kf.time,
                x,
                this.y + this.height / 2,
                10,
                10,
                this.primaryColor.value
            );
            this.keyframeObjects.push(newKFObj);
        }
        // this.addObject(...this.keyframeObjects);
    }

    init() {
        this.updateKeyframes();

        // this.background(this.primaryColor.toRGBA(0.2));
    }

    draw(context) {
        for (let kfo of this.keyframeObjects) kfo.draw(context);

        context.save();

        if (this.keyframes && this.keyframes.length > 1) {
            context.fillStyle = this.primaryColor.toRGBA(0.2);
            context.fillRect(this.x, this.y, this.width, this.height);
        }

        context.strokeStyle = "#00000000";
        context.fillStyle = this.primaryColor.toRGBA(0.2);
        context.lineWidth = 0;

        // Drawing lol
        for (let i = 1; i < this.keyframes.length; i++) {
            const currentKF = this.keyframes[i];
            const prevKF = this.keyframes[i - 1];

            const currentX = (currentKF.time / this.duration) * this.width;
            const prevX = (prevKF.time / this.duration) * this.width;

            // console.log(prevX, currentX);

            const currentY =
                this.height -
                ((currentKF.value - this.minValue) /
                    (this.maxValue - this.minValue)) *
                    this.height;
            const prevY =
                this.height -
                ((prevKF.value - this.minValue) /
                    (this.maxValue - this.minValue)) *
                    this.height;

            const easing = currentKF.easing || "linear";
            const bezier = Bezier.get(easing);

            const points = bezier.points;
            const { p1, p2 } = points;

            const w = currentX - prevX;
            const h = currentY - prevY;

            const CP1 = {
                x: p1.x * w + prevX,
                y: p1.y * h + prevY
            };

            const CP2 = {
                x: p2.x * w + prevX,
                y: p2.y * h + prevY
            };

            // console.log(CP1);

            context.beginPath();
            context.moveTo(this.x + prevX, this.y + prevY);
            context.bezierCurveTo(
                this.x + CP1.x,
                this.y + CP1.y,
                this.x + CP2.x,
                this.y + CP2.y,
                this.x + currentX,
                this.y + currentY
            );
            context.lineTo(this.x + currentX, this.y + this.height);
            context.lineTo(this.x + prevX, this.y + this.height);
            context.closePath();
            context.fill();
            context.stroke();
        }

        context.restore();
    }
}



// WEBPACK FOOTER //
// ./src/components/canvas/TOwObject.js